import React, { useState } from 'react'
//Para Documentacion
import PropTypes from 'prop-types';
//MUI
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
//Iconos
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

/**
 * <p>TexField ya configurado para ingresar informacion que debe estar oculta como por ejemplo claves.</p>
 * Cualquier otra propiedad proporcionada sera controlada por el elemento raiz [TextField de Material-UI](https://material-ui.com/api/text-field/)
 */
const PasswordDS = (props) => {
    const {toggle, ...other} = props;
    //Estados
    const [showPass, setShowPass] = useState(false);
    //Handlers
    const handleClickShowPassword = () => {
        setShowPass(!showPass);
    };

    const handleMouseDownPassword = event => {
        event.preventDefault();
    };

    return (
        <TextField
            data-testid="idTextFieldPasswordDS"
            type={showPass ? 'text' : 'password'}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {toggle ?
                            <IconButton
                                edge="end"
                                aria-label="cambiar visibilidad de clave"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                data-testid="idIconButtonPasswordDS"
                            >
                                {showPass ? <VisibilityOff /> : <Visibility />}
                            </IconButton> : <></>
                        }
                    </InputAdornment>
                ),
            }}
            {...other}
        />
    );
}

PasswordDS.propTypes = {
    /**
     * Si es true, se puede cambiar la visivilidad del contenido entre oculto y texto plano.
     */
    toggle: PropTypes.bool,
}
PasswordDS.defaultProps = {
    toggle: false,
}
export default PasswordDS;